import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 9.9.",
  "description": "",
  "published": "2011-09-09T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-9-9/swizec/2402"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-Chocolate_Fondant1.jpg",
        "alt": "Chocolate Fondant Cake/Lava cake",
        "title": "Chocolate Fondant Cake/Lava cake"
      }}></img></p>
    <p>{`Today I learned an important lesson about energy levels. Apparently I have gotten too old to withstand a week of focused studying and then having the energy to go out on Friday. Seriously, my body and mind just don't want to do it.`}</p>
    <p>{`Or maybe I'm just a nerd and the whole friday night thing takes too much of my energy anyway and isn't actually as relaxing as some people find it.`}</p>
    <p>{`Another thing I learned is that some people consider sex to be a very strange thing. Got into a discussion about marriage and stuff with a religious guy (one of those that actually decides to `}<em parentName="p">{`become`}</em>{` religious in their late teens, yeah) ... technically this was last night ... at one point we came to the agreement that marriage only matters if you intend to have kids, but he added that if you don't intend to have kids then you don't need to have sex anyway and the whole discussion is moot.`}</p>
    <p>{`This figuratively kept me up all night and today I jotted down my thoughts on the matter:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Happiness is getting the last cookie from the box,
it's that kiss from a hot girl before she even knows your name,
it's a box of chocolates from a stranger,
a hug from the person you secretly adore,
the awkward smile on the bartendress when you pay her a random compliment,
happiness is a bunch of small little things,
do something small for a change,
let the big things in life take care of themselves,
they always do.`}</p>
    </blockquote>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.vanguardngr.com/2011/09/why-men-are-not-eager-to-get-married-today/"
        }}>{`Why Men are not eager to get Married Today`}</a>{` (vanguardngr.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.dumblittleman.com/2011/09/keys-to-leading-happy-and-fullfilled.html"
        }}>{`Keys to Leading a Happy and Fullfilled Life`}</a>{` (dumblittleman.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fitsugar.com/Banana-Carob-Protein-Bar-Recipe-18559665"
        }}>{`A Reader Recipe: Banana-Carob Protein Bars`}</a>{` (fitsugar.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=006d3483-1e9d-4e2e-b30a-5772c4b0a551",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      